<div class="notyf__toast notyf__toast--success notyf__toast ms-4"
     [style.border-right-color]="selectedType.color">
    <div class="d-flex align-items-center justify-content-between notyf__wrapper">
        <div class="d-flex">
            <div class="d-flex align-items-center pe-0">
                <morva-icons
                        class="notyf__icon--success"
                        [icon]="selectedType.icon"
                ></morva-icons>
            </div>
            <div class="notyf__message ps-4">
                <div class="d-flex justify-content-start align-items-center messege-height">
                    <div class="toast-title">{{ title }}</div>
                    <div class="toast-message">{{ message }}</div>
                </div>
            </div>
        </div>

        <div class="pe-3" *ngIf="options.closeButton">
            <morva-icons
                    class="notyf-close-button white-icon"
                    icon="close"
                    (click)="remove()"></morva-icons>
        </div>
    </div>
    <div class="notyf__ripple"></div>
</div>
